import { useTranslation } from 'react-i18next';

import { currencyFormat } from '~/lib/i18n';
import { cn } from '~/utils/cnTailwind';

type Props = {
    total: number;
};

export const HouseholdBudgetTotal: React.FC<Props> = ({ total }) => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col gap-3 rounded-md bg-surface-light p-4 text-sm text-midnight">
            <p>
                {t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.SURPLUS')} /{' '}
                {t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.SHORTFALL')}
            </p>
            <div className="flex justify-between gap-4 font-bold">
                <span>
                    {total >= 0
                        ? t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.SURPLUS')
                        : t('BANK_CREDIT_REQUEST.ADDITIONAL_INFO.SHORTFALL')}
                </span>
                <span className={cn(total >= 0 ? 'text-green' : 'text-red-600')}>{currencyFormat(total)}</span>
            </div>
        </div>
    );
};
